import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { EmailsSettingEntity } from '../entities';
import { EmailsSettingState } from '../states';

export const emailsSettingAdapter: EntityAdapter<EmailsSettingEntity> = createEntityAdapter<EmailsSettingEntity>();
export const initialState: EmailsSettingState = emailsSettingAdapter.getInitialState({
    data: null,
    isLoading: false,
    isLoaded: false
});